import { Action } from 'redux';
import { UPDATE_METADATA } from '../actions/metaData';

const initialState = {
  framework: {
    automationTool: 'Selenium',
    language: 'Java',
    testFramework: 'TestNG',
    name: '',
  },
};

export default function metaData(state = initialState, action: Action<string>) {
  const { type, payload = {} as any }: any = action;
  switch (type) {
    case UPDATE_METADATA:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}
